import { render, staticRenderFns } from "./ChallengeForm.vue?vue&type=template&id=7771c938"
import script from "./ChallengeForm.vue?vue&type=script&lang=js"
export * from "./ChallengeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports